
<template>
    <form action="/subscribe" method="POST" id="payment-form" @submit.prevent="pay()">

      <div v-if="selected_plan">
        <h1 class="display-3 font-secondary text-center mt-3 mb-0">£{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) + (parseFloat(selected_plan.user_login_price.replace(/[^\d.]/g, '')) * parseInt(users))) }}</h1>
        <p class="text-center">per month, billed {{ selected_plan.period.toLowerCase() }}</p>
      </div>


      <div class="form-group">

          <select ref="plan" name="plan" class="form-control" id="plans" @change="updateSelected">
            <option v-for="(plan, plan_id) in plans" :value="plan['id']">{{ plan['name'] }}</option>
          </select>

      </div>

      <div class="form-group">
          <label for="name_on_card">Name on Card</label>
          <input type="text" class="form-control" id="name_on_card" name="name_on_card" required v-model="name_on_card">
      </div>


      <div class="form-group">
          <label for="card-element">Credit Card</label>

          <div id="card-element"></div>


      </div>



      <!-- CSRF Field -->
      <input type="hidden" name="_token" :value="csrf">

      <div class="spacer"></div>

      <button id="card-button" class="btn btn-primary btn-block btn-lg" :data-secret="secret">
          Sign Up!
      </button>

      <div v-if="selected_plan" class="text-center pt-2">

        <small v-if="selected_plan.period == 'Monthly'"  class="text-muted">Your card will be charged £{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) * parseInt(users)).toFixed(2) }} + VAT today and ongoing {{ selected_plan.period.toLowerCase() }} for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small>
        <small v-if="selected_plan.period == 'Annually' || selected_plan.period == 'Yearly'"  class="text-muted">Your card will be charged £{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) * parseInt(users) * 12).toFixed(2) }} + VAT today and ongoing {{ selected_plan.period.toLowerCase() }} for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small>

        <!-- <small v-if="selected_plan.period == 'Annually'" class="text-muted">Your card will be charged £{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) + (parseFloat(selected_plan.user_login_price.replace(/[^\d.]/g, '')) * parseInt(users))).toFixed(2) }} +VAT for a full year's access for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small>
        <small v-if="selected_plan.period == 'Monthly'" class="text-muted">Your card will be charged £{{ ((parseFloat(selected_plan.price.replace(/[^\d.]/g, ''))) + (parseFloat(selected_plan.user_login_price.replace(/[^\d.]/g, '')) * parseInt(users))).toFixed(2) }} +VAT for a month's access for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small>
        <small v-if="selected_plan.period !== 'Annually' && selected_plan.period !== 'Monthly'" class="text-muted">Your card will be charged {{ selected_plan.price }} +VAT today and ongoing {{ selected_plan.period }} for {{ users }} user<span v-if="parseInt(users) !== 1">s</span>.</small> -->
      </div>

  </form>
</template>

<script>

import Noty from 'noty';

    export default {
        props: [
            'pk',
            'secret',
            'users',
        ],
        mounted(){

          var vm = this;

          axios.get('/billing/list-plans').then(response => {

            vm.plans = response.data;

            vm.selected_plan = response.data[0];


          }).catch(function(error){ vm.handleError(error) });

              this.stripe = Stripe(this.pk);

              const elements = this.stripe.elements();
              this.cardelement = elements.create('card',{
                style: {
                  base: {
                    color: '#32325d',

                    fontFamily: '"Nunito", sans-serif',
                    fontSize: '14.4px',
                    '::placeholder': {
                      color: '#aab7c4'
                    }
                  },
                  invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                  }
                },
                hidePostalCode: false
              });

              this.cardelement.mount('#card-element');


        },
        data () {
            return {
              stripe:'',
              cardelement:'',
              csrf: document.head.querySelector('meta[name="csrf-token"]').content,
              name_on_card: '',
              plans: null,
              selected_plan: null,
            }
        },
        methods: {
            updateSelected: function(){

              console.log(this.$refs.plan.value);
              console.log(this.plans[0]['id']);

              this.selected_plan = this.plans.find(plan => plan.id == this.$refs.plan.value);

            },
            pay: async function () {

              const cardHolderName = document.getElementById('name_on_card');
              const cardButton = document.getElementById('card-button');
              const clientSecret = cardButton.dataset.secret;
              var vm = this;
              const { setupIntent, error } = await vm.stripe.confirmCardSetup(
                  clientSecret, {
                      payment_method: {
                          card: vm.cardelement,
                          billing_details: { name: vm.name_on_card }
                      }
                  }
              );

              if (error) {
                  // Display "error.message" to the user...

                  var message = error.message;

                  new Noty({
                      text: 'Error: ' + message,
                      type: 'error',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: false
                  }).show();

                  //console.log(error);

              } else {
                  var hiddenInput = document.createElement('input');
                  hiddenInput.setAttribute('type', 'hidden');
                  hiddenInput.setAttribute('name', 'stripePaymentMethodToken');
                  hiddenInput.setAttribute('value', setupIntent.payment_method);
                  this.$el.appendChild(hiddenInput);
                  // Submit the form
                  this.$el.submit();
              }




            }
      }
    }
</script>
